export default "__VITE_ASSET__BrNpy7fB__"